// extracted by mini-css-extract-plugin
module.exports = {"fileUploadWrapper":"UploadBranchData_fileUploadWrapper__3h4J4","fileInput":"UploadBranchData_fileInput__15fuf"};